module.exports = __webpack_public_path__ + "img/logo_china.8864e6bd.png";